import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { labelActions } from '@common-reducers/labels-reducer';
import { newLabelThunk } from '@common-reducers/labels-reducer/labels-thunks/crud';
import { WaChatSelectors } from '@common/reducers/DBServiceThunks';
import { Close } from '@mui/icons-material';
import { ButtonBase, Checkbox, CircularProgress, MenuItem, colors } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import LabelInput from '../label-input';
import mainClasses from '../labels-feature.module.scss';
import classes from './modal.module.scss';
import TalkToUsFooter from './talktous-footer';
import { useTranslation } from 'react-i18next';
import { namespace } from "@common-config/constants";



export default function SortChatsToNewLabel() {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch()
    const chatList = useAppSelector(WaChatSelectors.selectAll)
    const label = useAppSelector((state) => state.LabelReducer.label)
    const isSortChatToLabelModalOpen = useAppSelector((state) => state.LabelReducer.isSortChatToLabelModalOpen)
    const labelNetWorkStatus = useAppSelector((state) => state.LabelReducer.labelNetWorkStatus)


    function handleOnChange() {

    }



    return (
        <div>

            <Modal
                open={isSortChatToLabelModalOpen}
                onClose={() => dispatch(labelActions.toggleSortChatToLabelModalOpen(false))}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={classes.sortChatToLabelcontainer}>
                    <Box className={classes.modalHead}>
                        <Typography id="modal-modal-title"
                            sx={{ flex: 1, fontWeight: 600 }} variant="h6" component="h2">
                            {t('labels.sortChatToNewLabel', { labelName: label.name })}
                        </Typography>

                        <ButtonBase
                            className={classes.closeModalButton}
                            sx={{ width: 35, height: 35 }}
                            onClick={() => dispatch(labelActions.toggleNewLabel(false))}
                        >
                            <Close sx={{ fontSize: '25px' }} />
                        </ButtonBase>
                    </Box>
                    <Box sx={{
                        height: 45,
                        display: 'flex',
                        alignItems: 'center',
                        borderRadius: '10px',
                        margin: '0 15px',
                        border: `1px solid var(--tasks-menu-hover-bg)eee`
                    }}>
                        <LabelInput value='' onChange={handleOnChange} placeholder={t('labels.searchChatByName')} />

                    </Box>
                    <Box className={classes.ChatsWrapper}>
                        {chatList.map((chat, index) => (
                            <MenuItem key={index} sx={{ width: '100%', bgcolor: 'var(--color-surface)', borderBottom: `1px solid var(--tasks-menu-hover-bg)eee` }}>
                                <Checkbox /> <img src={chat?.contact?.profilePicThumb?.profilePicUrl ?? ''} alt='' />  {chat.contact?.displayName ?? ''}
                            </MenuItem>
                        ))}
                    </Box>

                    <Box className={classes.suggestedLabels}>
                        <Box className={classes.createWrap} sx={{ gap: 2 }}>
                            <ButtonBase
                                className={mainClasses.labelButtonBase}
                                onClick={() => dispatch(labelActions.toggleSortChatToLabelModalOpen(false))}
                                sx={{
                                    flexBasis: '40%!important',
                                    bgcolor: label.name ? '#546eff!important' : '',
                                    color: label.name ? 'var(--color-surface)!important' : '',
                                    '&:hover': {
                                        color: labelNetWorkStatus === 'create-label' ? '' : 'var(--color-surface)',
                                        backgroundColor: labelNetWorkStatus === 'create-label' ? colors.grey[200] : '#546eff',
                                    }
                                }}>
                                {t('labels.skipForNow')}
                            </ButtonBase>

                            <ButtonBase
                                className={mainClasses.labelButtonBase}
                                onClick={() => dispatch(newLabelThunk())}
                                sx={{
                                    flexBasis: '40%!important',
                                    bgcolor: label.name ? '#546eff!important' : '',
                                    color: label.name ? 'var(--color-surface)!important' : '',
                                    '&:hover': {
                                        color: labelNetWorkStatus === 'create-label' ? '' : 'var(--color-surface)',
                                        backgroundColor: labelNetWorkStatus === 'create-label' ? colors.grey[200] : '#546eff',
                                    }
                                }}>
                                {labelNetWorkStatus === 'create-label' ? t('labels.saving') : t('common.save')}
                                {labelNetWorkStatus === 'create-label' && <CircularProgress size={16} sx={{
                                    ml: 1,
                                }} />}
                            </ButtonBase>

                        </Box>
                    </Box>
                    <TalkToUsFooter />
                </Box>
            </Modal>
        </div >
    );
}

